import { render, staticRenderFns } from "./new_multiple_manipulated_orders.vue?vue&type=template&id=48026e37&lang=pug&"
import script from "./new_multiple_manipulated_orders.vue?vue&type=script&lang=js&"
export * from "./new_multiple_manipulated_orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports